import React from 'react'
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/main.css";

export default function StarRating({ rating }) {
  return (
    <div className="fs-5 star-rating">
      {[1,2,3].map(i => (
        <i
          key={i}
          className={
            i <= rating
              ? "bi bi-star-fill"
              : i - rating === 0.5
              ? "bi bi-star-half"
              : "bi bi-star-fill star-rating-light"
          }
        ></i>
      ))}
    </div>
  );
}
